import type { ElementTransform } from "../types";
import type { LayoutSlots } from "./types";

const GAP_X = 2;
const GAP_Y = 2.5;

/** Horizontally mirror a transform across the canvas center (for RTL layouts). */
export function mirrorTransformX(t: ElementTransform): ElementTransform {
    return { ...t, x: 100 - t.x - t.width };
}

/**
 * Mirror a layout's text + media slots horizontally for RTL, matching how the
 * original `flex-row` templates auto-reversed (e.g. template B: text on the
 * right, media on the left). The avatar keeps its own saved position.
 */
export function mirrorSlotsForRtl(slots: LayoutSlots): LayoutSlots {
    return {
        ...slots,
        text: slots.text ? mirrorTransformX(slots.text) : undefined,
        media: slots.media ? mirrorTransformX(slots.media) : undefined,
    };
}

/** Tile `n` boxes inside a region (canvas %), as a near-square grid with gaps. */
export function tileRegion(
    region: ElementTransform,
    n: number
): ElementTransform[] {
    if (n <= 1) return [{ ...region }];
    const cols = Math.ceil(Math.sqrt(n));
    const rows = Math.ceil(n / cols);
    const cellW = (region.width - GAP_X * (cols - 1)) / cols;
    const cellH = (region.height - GAP_Y * (rows - 1)) / rows;
    const out: ElementTransform[] = [];
    for (let i = 0; i < n; i++) {
        const row = Math.floor(i / cols);
        const col = i % cols;
        out.push({
            x: region.x + col * (cellW + GAP_X),
            y: region.y + row * (cellH + GAP_Y),
            width: cellW,
            height: cellH,
            rotation: 0,
        });
    }
    return out;
}
